import {
  FETCH_NEAR_STORE_DATA,
  FETCH_NEAR_STORE_DATA_SUCCESS,
  FETCH_NEAR_STORE_DATA_FAILURE,
  FETCH_COORDINATES_REQUEST,
  FETCH_COORDINATES_SUCCESS,
  FETCH_COORDINATES_FAILURE,
  SET_SESSIONSTORAGE_VALUE,
  GET_SERVICE_BY_ID_REQUEST, 
  GET_SERVICE_BY_ID_SUCCESS, 
  GET_SERVICE_BY_ID_FAILURE,
  GET_SERVICE_BY_ID_FOR_LOCATION_REQUEST, 
  GET_SERVICE_BY_ID_FOR_LOCATION_SUCCESS, 
  GET_SERVICE_BY_ID_FOR_LOCATION_FAILURE
} from "../actions/location/types";

const initialState = {
  Stores: null,
  loading: false,
  hasErrors: false,
  locationDetails : null,
  sessionStore: false,
  maxCount: null,
  serviceById: {
    data: {},
    loading: false,
    error: {},
  },
  serviceByIdForLocation: {
    data: {},
    loading: false,
    error: {},
  }
};

export default function locationReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_NEAR_STORE_DATA:
      return { ...state, loading: action.isLoading };
    case FETCH_NEAR_STORE_DATA_SUCCESS:
      return { Stores: action.data, loading: action.isLoading, hasErrors: action.error };
    case FETCH_NEAR_STORE_DATA_FAILURE:
      return { ...state, loading: action.isLoading, hasErrors: action.errordata };
    case FETCH_COORDINATES_REQUEST:
      return { ...state, loading: action.isLoading };
    case FETCH_COORDINATES_SUCCESS:
      return { ...state, loading: action.isLoading, locationDetails: action.payload };
    case FETCH_COORDINATES_FAILURE:
      return { ...state, loading: action.isLoading, hasErrors: action.payload };
    case SET_SESSIONSTORAGE_VALUE:
      return { ...state, loading: action.isLoading, sessionStore: action.payload };
    case GET_SERVICE_BY_ID_REQUEST:
      return { ...state, serviceById: { ...state.serviceById, loading: action.isLoading, error: null } };
    case GET_SERVICE_BY_ID_SUCCESS:
      return { ...state, serviceById: { loading: action.isLoading, data: action.data, error: null } };
    case GET_SERVICE_BY_ID_FAILURE:
      return { ...state, serviceById: { ...state.serviceById, loading: action.isLoading, error: action.error } };
    case GET_SERVICE_BY_ID_FOR_LOCATION_REQUEST:
      return { ...state, serviceByIdForLocation: { ...state.serviceByIdForLocation, loading: action.isLoading, error: null } };
    case GET_SERVICE_BY_ID_FOR_LOCATION_SUCCESS:
      return { ...state, serviceByIdForLocation: { loading: action.isLoading, data: action.data, error: null } };
    case GET_SERVICE_BY_ID_FOR_LOCATION_FAILURE:
      return { ...state, serviceByIdForLocation: { ...state.serviceByIdForLocation, loading: action.isLoading, error: action.error } };
    default:
      return state;
  }
}
